<template>
  <v-chip
    close
    outlined
    close-icon="mdi-alert"
    elevation="0"
    color="grey"
    class=""
    v-if="requiredChip"
    @click:close="requiredChip = false"
  >
    Account is required for reccuring payments
  </v-chip>
</template>
<script>
export default {
  data () {
    return {
      requiredChip: true
    }
  }
}
</script>
